import { LoaderConstants } from './loader.constants'
import { ILoaderState, ILoaderAction } from './loader.types'

export const initialLoaderState: ILoaderState = {
  isOpen: false,
  showBackdrop: true,
  message: '',
  spinner: 'crescent',
}

export function loaderReducer(state: ILoaderState = initialLoaderState, action: ILoaderAction): ILoaderState {
  switch (action.type) {
    case LoaderConstants.SHOW_LOADER:
      return { ...state, ...action.loader, isOpen: true }
    case LoaderConstants.HIDE_LOADER:
      return { ...state, isOpen: false }
    case LoaderConstants.RESET_LOADER:
      return initialLoaderState
    default:
      return state
  }
}
